import {useEffect, useRef} from 'react'
import {useDispatch} from 'react-redux'
import {off} from 'firebase/database'
import {OrderModel} from '../models/OrderModel'
import {OrderItemModel} from '../models/OrderItemModel'
import {listenOrderDetailChange, listenOrderItemsChange} from '../firebase/order'
import {updateCurrent, updateCurrentOrderItems} from '../redux/OrderRedux'

/**
 * Custom hook that manages Firebase realtime listeners for order detail and items.
 * Subscribes on mount, unsubscribes on unmount. Dispatches Redux updates on change.
 */
export function useOrderRealtime(orderId: string) {
  const dispatch = useDispatch()
  const orderListenerRef = useRef<ReturnType<typeof listenOrderDetailChange>>(undefined)
  const itemListenerRef = useRef<ReturnType<typeof listenOrderItemsChange>>(undefined)

  useEffect(() => {
    orderListenerRef.current = listenOrderDetailChange(orderId, (order: OrderModel) => {
      if (order && order.status) {
        dispatch(updateCurrent(order))
      }
    })

    itemListenerRef.current = listenOrderItemsChange(orderId, (items: OrderItemModel[]) => {
      if (items) {
        const orderItems = Object.values(items)
        if (orderItems.length > 0) {
          dispatch(updateCurrentOrderItems(orderItems))
        }
      }
    })

    return () => {
      if (orderListenerRef.current) {
        off(orderListenerRef.current)
      }
      if (itemListenerRef.current) {
        off(itemListenerRef.current)
      }
    }
  }, [orderId, dispatch])
}
